var render, staticRenderFns
import script from "./PieOverview.vue?vue&type=script&lang=js&"
export * from "./PieOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103bbde",
  null
  
)

export default component.exports